export enum EmployeeModulesEnum {
    ORDER = 'ORDER',
    TABLE_RESERVATION = 'TABLE_RESERVATION',
    MENU = 'MENU',
    FOOD_PACKAGES = 'FOOD_PACKAGES',
    PROMO_SET = 'PROMO_SET',
    INVENTORY = 'INVENTORY',
    CLIENTS = 'CLIENTS',
    REVIEWS = 'REVIEWS',
    PROMO_CODES = 'PROMO_CODES',
    LOYALTY_PROGRAM = 'LOYALTY_PROGRAM',
    SPECIAL_OFFER = 'SPECIAL_OFFER',
    COUPONS = 'COUPONS',
    MARKETING_CAMPAIGN = 'MARKETING_CAMPAIGN',
    MARKETING_AUTOMATION = 'MARKETING_AUTOMATION',
    RESTAURANT_MANAGEMENT = 'RESTAURANT_MANAGEMENT',
    SETTINGS = 'SETTINGS',
    BILLINGS = 'BILLINGS',
    EMPLOYEES = 'EMPLOYEES',
    COURIERS = 'COURIERS',
    INTEGRATIONS = 'INTEGRATIONS',
    APP_CONFIGURATOR = 'APP_CONFIGURATOR',
    WEB_CONFIGURATOR = 'WEB_CONFIGURATOR',
    FOOD_INTEGRATORS = 'FOOD_INTEGRATORS',
    INVOICES = 'INVOICES',
    CROSS_SELLING = 'CROSS_SELLING',
}
